import React, { Component } from "react";
import { Row, Col, Button, Input, Menu, Dropdown, Divider, Badge, Breadcrumb } from "antd";
import { AiOutlineSearch } from "react-icons/ai";
import { connect } from "react-redux";
import { UserAction, AuthAction, CatalogAction } from "../../store/actions";
import rmxAboutCover from "../../assets/images/about-bg.png";
import rmxTotalPlant from "../../assets/images/total-plants.png";
import rmxTotalProducts from "../../assets/images/total-products.png";
import BussinessCard from "../../../contractor/components/EmployeCard/plantInfoCard";
import "./index.css";
import Category from "../../components/CategoriesCard";
import CatalogCard from "../../components/catalogCard";
import AddProduct from "../../components/rmxplant/addProduct";
import CheckoutProgress from "../../components/CheckoutProgress";
import CheckoutCard from "../../components/checkoutCard";
import OrderNoteCard from "../../components/OrderNote";
import PaymentCard from "../../components/PaymentCard";
import ShoppingCart from "../../components/rmxplant/shoppingcart";
import OrderSuccess from "../../components/rmxplant/orderSucces";
import CustomModal from "../../components/modals/customModal";
import TextInput from "../../components/input/TextInput";
import LoaderGif from "../../assets/images/ie_loader.gif";
import CrossIcom from "../../assets/images/cross.png";
import personCartIcon from "../../assets/images/person-cart.png";
import bucketCartIcon from "../../assets/images/bucket-cart.png";
import { numberWithCommas } from "../../config/utils";
import { formatToNumber } from "../../config/utils";
import { EMAIL_REGX } from "../../config/variables";
import {
  IoPersonSharp,
  AiOutlineShoppingCart,
  GiPlainCircle,
  MdPersonOutline,
} from "react-icons/all";
// import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Cookies from "universal-cookie";
import info from "../../components/info";

const cookies = new Cookies();
// import { width } from "@mui/system";
class PlantDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisabled: false,
      cart: [],
      keyTab: 1,
      filters: {
        order: "asc",
        page: 1,
        per_page: 12,
        column: "name",
        category_id: 1,
        status: "active",
      },

      categoryName: "",
      isshowAddProduct: false,
      addproduct: {},
      isCheckout: false,
      isShipping: false,
      isBilling: false,
      isOrderNote: false,
      isOrderReview: false,
      addressPayload: {
        address_type: "",
        contractor_address_id: "",
      },
      orderDataAddress: [],
      billingAddressName: "",
      shippingAddressName: "",
      showBillingAddressField: "",
      showShippingAddressField: "",
      paymentCardId: "",
      isPayment: false,
      isShopingCart: false,
      isShopping: false,
      checkProgressValue: "Billing Address",
      checkProgress: [
        {
          name: "Billing Address",
          isChecked: false,
        },
        {
          name: "Shipping Address",
          isChecked: false,
        },
        // {
        //   name: "Order Notes",
        //   isChecked: false,
        // },
        {
          name: "Payment Method",
          isChecked: false,
        },
        {
          name: "Order Review",
          isChecked: false,
        },
      ],
      totalPrice: 0,
      quntity: 1,
      checkoutPayload: {
        purchase_order_num: "",
        preferred_delivery_datetime: "",
        preferred_delivery_period: "pm",
      },
      placeOrderData: [],
      rmx_company_id: "",
      order_note: "",
      cardId: "",
      paymentType: "credit-purchase",
      error: {
        preferred_delivery_datetimeError: "",
        addressError: "",
        paymentError: "",
        purchaseOrderError: "",

      },
      isOrderSuccess: false,
      counter: 0,
      quantityArr: [],
      priceArr: [],
      isOpenCard: false,
      cardDetails: {
        number: "",
        exp_year: "",
        exp_month: "",
        cvc: "",
      },
      cardDetailError: {
        numberError: "",
        exp_yearError: "",
        exp_monthError: "",
        cvcError: "",
      },
      contractorUser: [],
      isAchDisable: true,
      ishideCrossIcon: false,
      dateIndex: "",
      preferedTime: "pm",
      isShowLoginModal: false,
      userObj: {
        email: "",
        password: "",
      },
      errorObj: {
        emailError: "",
        passwordError: "",
      },
      authError: "",
    };
  }

  abc = (key) => {
    this.setState({
      filters: {
        ...this.state.filters,
        category_id: key.id,
        page: 1,
      },
      isshowAddProduct: false,
      categoryName: key.name,
    });
  };



  componentDidMount() {


    const { getCategories, getProducts, getStoreUrl, location } = this.props;
    // if (!localStorage.getItem("storeInfo")) {
    //   localStorage.setItem("rmxUser", JSON.stringify(location.state));
    // }
    const response = cookies.get("contractor_credentials");
    if (response) {
      localStorage.setItem("access_token_contractor", response.token);
      localStorage.setItem(
        "trkr_contractor_auth",
        JSON.stringify(response.data)
      );
    }

    // getStoreUrl({ storeName: location.state?.rmx_company_asset?.store_url });
    getCategories();
    if (localStorage.getItem("cart")) {
      this.setState({
        cart: JSON.parse(localStorage.getItem("cart")),
      });
    }
    this.props.history.push("");
    window.addEventListener(
      "popstate",
      (event) => {
        //  this.props.history.pushState(null, null, window.location.pathname);
        console.log("location_params", window.location.pathname);
        const url =
          window.location.hash.split("/")[
          window.location.hash.split("/").length - 1
          ];
        if (url === "") {
          this.setState({
            isCheckout: false,
            isShipping: false,
            isBilling: false,
            isOrderNote: false,
            isOrderReview: false,
            isshowAddProduct: false,
            isShopingCart: false,

            checkProgress: [
              {
                name: "Billing Address",
                isChecked: false,
              },
              {
                name: "Shipping Address",
                isChecked: false,
              },
              // {
              //   name: "Order Notes",
              //   isChecked: false,
              // },
              {
                name: "Payment Method",
                isChecked: false,
              },
              {
                name: "Order Review",
                isChecked: false,
              },
            ],

            checkProgressValue: "Billing Address",
            keyTab: 1,
            addressPayload: {
              address_type: "",
              contractor_address_id: "",
            },
            ishideCrossIcon: false,
          });
        } else if (url === "product") {
          this.setState({
            isCheckout: false,
            isShipping: false,
            isBilling: false,
            isOrderNote: false,
            isOrderReview: false,
            isshowAddProduct: true,
            isShopingCart: false,

            checkProgress: [
              {
                name: "Billing Address",
                isChecked: false,
              },
              {
                name: "Shipping Address",
                isChecked: false,
              },
              // {
              //   name: "Order Notes",
              //   isChecked: false,
              // },
              {
                name: "Payment Method",
                isChecked: false,
              },
              {
                name: "Order Review",
                isChecked: false,
              },
            ],

            checkProgressValue: "Billing Address",
            addressPayload: {
              address_type: "",
              contractor_address_id: "",
            },
            ishideCrossIcon: false,
          });
        } else if (url === "shoppingcart") {
          this.setState({
            isPayment: false,
            isOrderNote: false,
            isCheckout: false,
            isShipping: false,
            isBilling: false,
            isOrderNote: false,
            isOrderReview: false,
            isshowAddProduct: true,
            isShopingCart: true,
            isOrderReview: false,
            isOrderSuccess: false,
            checkProgress: [
              {
                name: "Billing Address",
                isChecked: false,
              },
              {
                name: "Shipping Address",
                isChecked: false,
              },
              // {
              //   name: "Order Notes",
              //   isChecked: false,
              // },
              {
                name: "Payment Method",
                isChecked: false,
              },
              {
                name: "Order Review",
                isChecked: false,
              },
            ],

            checkProgressValue: "Billing Address",
            addressPayload: {
              address_type: "",
              contractor_address_id: "",
            },

            ishideCrossIcon: false,
          });
        } else if (url == "aboutus") {
          this.setState({
            isCheckout: false,
            isShipping: false,
            isBilling: false,
            isOrderNote: false,
            isOrderReview: false,
            isshowAddProduct: false,
            isShopingCart: false,

            checkProgress: [
              {
                name: "Billing Address",
                isChecked: false,
              },
              {
                name: "Shipping Address",
                isChecked: false,
              },
              // {
              //   name: "Order Notes",
              //   isChecked: false,
              // },
              {
                name: "Payment Method",
                isChecked: false,
              },
              {
                name: "Order Review",
                isChecked: false,
              },
            ],

            checkProgressValue: "Billing Address",
            addressPayload: {
              address_type: "",
              contractor_address_id: "",
            },
            ishideCrossIcon: false,
          });
        }
      },
      false
    );
  }

  componentDidUpdate(preProps, preState) {



    const { getProducts, error, categories } = this.props;
    if (!this.state.cart?.length && preState.cart?.length !== this.state.cart?.length) {
      if (!this.state.isOrderSuccess && this.state.isShopingCart) {
        console.log("dsfew");

        this.setState({

          checkoutPayload: {
            ...this.state.checkoutPayload,
            preferred_delivery_datetime: "",
            purchase_order_num: "",
          },
          addressPayload: {
            address_type: "",
            contractor_address_id: "",
          },
          checkProgressValue: "Billing Address",
          checkProgress: [
            {
              name: "Billing Address",
              isChecked: false,
            },
            {
              name: "Shipping Address",
              isChecked: false,
            },
            // {
            //   name: "Order Notes",
            //   isChecked: false,
            // },
            {
              name: "Payment Method",
              isChecked: false,
            },
            {
              name: "Order Review",
              isChecked: false,
            },
          ],
          order_note: "",
          billingAddressName: "",
          shippingAddressName: "",
          showBillingAddressField: "",
          showShippingAddressField: "",
          paymentType: "credit-purchase",
          paymentCardId: "",
          isOrderReview: false,
          isAchDisable: true,
          ishideCrossIcon: true,
          isShopingCart: true,
          isshowAddProduct: false,
          isOrderSuccess: false,
          ishideCrossIcon: false,
        });
      }
    }
    if (
      preState.isShopingCart !== this.state.isShopingCart ||
      preState.isshowAddProduct !== this.state.isshowAddProduct
    ) {
      this.setState({
        cart: JSON.parse(localStorage.getItem("cart")),
      });
    }
    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filters: {
          ...this.state.filters,
          page: this.props?.metaData?.current_page,
          total_records: this.props?.metaData?.total_records,
          current_records: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }
    if (
      preState.filters.search !== this.state.filters.search ||
      preState.filters.column !== this.state.filters.column ||
      preState.filters.per_page !== this.state.filters.per_page ||
      preState.filters.page !== this.state.filters.page ||
      preState.filters.category_id !== this.state.filters.category_id
    ) {
      getProducts(this.state.filters);
    }
    if (preProps.error !== this.props.error) {
      this.setState({
        authError: this.props.error,
      });
    }
    if (preProps?.categories?.length !== categories?.length) {
      getProducts(
        { ...this.state.filters, category_id: categories?.[0]?.id },
        false
      );
      console.log("categoriesUpdate==>", categories);
      this.setState({
        categoryName: categories?.[0]?.name,
      });
    }
  }

  currentPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page - 1,
      },
    });
  };

  onAchDisable = (e) => {
    this.setState({
      isAchDisable: e,
    });
  };

  onChangeFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        column: value,
      },
    });
  };
  onFilterSearch = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        search: value,
      },
    });
  };

  onChangeShowingFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        per_page: value,
      },
    });
  };
  addproductData = (e) => {
    console.log("data==>", e);
    this.setState({
      addproduct: e,
    });
  };
  cardHandleChanged = (e) => {
    this.setState({
      cardDetails: {
        ...this.state.cardDetails,
        [e.target.name]: e.target.value,
      },
      cardDetailError: {
        ...this.state.cardDetailError,
        [`${e.target.name}Error`]: "",
      },
    });
  };
  onSubmitCard = () => {
    const { number, cvc, exp_month, exp_year, name } = this.state.cardDetails;
    if (
      !number.trim().length ||
      !cvc.trim().length ||
      !exp_month.trim().length ||
      !exp_year.trim().length
    ) {
      if (!number.trim().length) {
        this.state.cardDetailError.numberError = "Card Number is required.";
      }
      if (!exp_month.trim().length) {
        this.state.cardDetailError.exp_monthError = "Expiry month is required.";
      }
      if (!exp_year.trim().length) {
        this.state.cardDetailError.exp_yearError = "Expiry year is required.";
      }
      if (!cvc.trim().length) {
        this.state.cardDetailError.cvcError = "Cvc is required.";
      }
      this.setState({
        cardDetailError: this.state.cardDetailError,
      });
      return;
    }
    this.setState({ isDisabled: true });

    this.props.createToken(
      this.state.cardDetails,
      () =>
        this.setState({
          isOpenCard: false,
          isDisabled: false,
        }),
      () => {
        this.setState({ isDisabled: false });
      }
    );
  };
  onChangeAddress = (type, id, e) => {
    console.log("typeewwe", type, e);
    let label = e.label
    const { addressPayload } = this.state;
    this.clearError();
    // debugger
    if (type == "billing") {
      this.setState({
        billingAddressName: label,
        showBillingAddressField: e,
        addressPayload: {
          ...this.state.addressPayload,
          address_type: type,
          contractor_address_id: id,
        },
      });
    }
    if (type == "shipping") {
      this.setState({
        shippingAddressName: label,
        showShippingAddressField: e,
        addressPayload: {
          ...this.state.addressPayload,
          address_type: type,
          contractor_address_id: id,
        },
      });
    }
    // this.setState({
    //   addressPayload: {
    //     ...this.state.addressPayload,
    //     address_type: type,
    //     contractor_address_id: id,
    //   },
    // });
  };
  onSubmitAddress = () => {

    const { checkProgress, addressPayload, showBillingAddressField } = this.state;
    console.log(" during addressPayload", showBillingAddressField);

    if (showBillingAddressField) {
      this.setState({
        // billingAddressName: label,
        // showBillingAddressField: e,
        addressPayload: {
          ...this.state.addressPayload,
          address_type: "billing",
          contractor_address_id: showBillingAddressField.id,
        },
      });

      const { orderData } = this.props;
      const arr = [...checkProgress];
      arr[0].isChecked = true;
      // this.props.postOrderAddress(this.state.addressPayload, orderData.id, (res) => {
      this.setState({
        // orderDataAddress: res,
        isCheckout: false,
        isShipping: true,
        isBilling: false,
        checkProgress: arr,
        addressPayload: {
          contractor_address_id: "",
        },
        checkProgressValue: "Shipping Address",
        // order_note: "",
        // billingAddressName: this.state.billingAddressName
      });
      this.props.getAddressReq();
      return
    }


    console.log("payyAdd", addressPayload);
    if (!addressPayload.contractor_address_id) {
      this.state.error.addressError = "Address is required.";
      this.setState({
        ...this.state.error,
        addressError: this.state.error.addressError,
      });
      return;
    }

    const { orderData } = this.props;
    const arr = [...checkProgress];
    arr[0].isChecked = true;
    // this.props.postOrderAddress(this.state.addressPayload, orderData.id, (res) => {
    this.setState({
      // orderDataAddress: res,
      isCheckout: false,
      isShipping: true,
      isBilling: false,
      checkProgress: arr,
      addressPayload: {
        contractor_address_id: "",
      },
      checkProgressValue: "Shipping Address",
      // order_note: "",
      // billingAddressName: this.state.billingAddressName
    });
    this.props.getAddressReq();
    // });
    // this.setState({
    //   billingAddressName: "maxxxx"
    // })

    console.log("im bii", addressPayload);
  };
  onSubmitShipAddress = () => {
    const { checkProgress, addressPayload } = this.state;
    const { orderData } = this.props;
    if (this.state.showShippingAddressField) {
      console.log("runnnnn");
      let payload = {
        ...this.state.addressPayload,
        address_type: "shipping",
        contractor_address_id: this.state.showShippingAddressField?.value
      }
      const arr = [...checkProgress];
      // arr[1].isChecked = true;
      // this.props.postOrderAddress(payload, orderData.id, (res) => {

      arr[1].isChecked = true;
      this.setState({
        // orderDataAddress: res,
        isCheckout: false,
        isShipping: false,
        isBilling: false,
        isOrderNote: false,
        isPayment: true,
        checkProgress: arr,
        checkProgressValue: "Payment Method",
      })
      // });
      return
    }
    if (!addressPayload.contractor_address_id) {
      this.state.error.addressError = "Address is required.";
      this.setState({
        ...this.state.error,
        addressError: this.state.error.addressError,
      });
      return;
    }
    else {

      const arr = [...checkProgress];
      // arr[1].isChecked = true;
      // this.props.postOrderAddress(this.state.addressPayload, orderData.id, () => {
      arr[1].isChecked = true;
      this.setState({
        isCheckout: false,
        isShipping: false,
        isBilling: false,
        isOrderNote: false,
        isPayment: true,
        checkProgress: arr,
        checkProgressValue: "Payment Method",
      })
      // });
    }
  };
  moveBackAndForward = (index, item) => {
    console.log("index move", index, item);
    const { checkProgress } = this.state;
    const arr = [...checkProgress];
    if (item.name == "Shipping Address" && item.isChecked == true) {
      arr[index].isChecked = true;
      this.setState({
        isCheckout: false,
        isShipping: true,
        isBilling: false,
        isOrderNote: false,
        isOrderReview: false,
        isPayment: false,
        checkProgress: arr,
        checkProgressValue: "Shipping Address",
      })

    }
    if (item.name == "Payment Method" && item.isChecked == true) {
      arr[index].isChecked = true;
      this.setState({
        isCheckout: false,
        isShipping: false,
        isBilling: false,
        isOrderNote: false,
        isPayment: true,
        isOrderReview: false,
        checkProgress: arr,
        checkProgressValue: "Payment Method",
      })

    }
    if (item.name == "Billing Address" && item.isChecked == true) {
      arr[index].isChecked = true;
      this.setState({
        isCheckout: true,
        isShipping: false,
        // isBilling: true,
        isOrderNote: false,
        isPayment: false,
        isOrderReview: false,
        checkProgress: arr,
        checkProgressValue: "Billing Address",
      })
    }

    if (item.name == "Order Review" &&
      this.state.checkProgress[0].isChecked == true &&
      this.state.checkProgress[1].isChecked == true &&
      this.state.checkProgress[2].isChecked == true
    ) {
      // arr[index].isChecked = true;
      this.setState({
        isCheckout: false,
        isShipping: false,
        // isBilling: true,
        isOrderNote: false,
        isPayment: false,
        isOrderReview: true,
        checkProgress: arr,
        checkProgressValue: "Order Review",
      })
    }

  }
  onSubmitNote = () => {
    const { checkProgress, order_note } = this.state;
    const { orderData, updateOrder } = this.props;
    const arr = [...checkProgress];
    updateOrder({ order_note }, orderData.id, () => {

      this.setState({
        isCheckout: false,
        isShipping: false,
        isBilling: false,
        isOrderNote: false,
        isPayment: true,
        checkProgress: arr,
        checkProgressValue: "Payment Method",
      });
    });
  };
  onCreditPurchase = () => {
    const { checkProgress } = this.state;
    const arr = [...checkProgress];
    arr[2].isChecked = true;
    this.setState({
      isCheckout: false,
      isShipping: false,
      isBilling: false,
      isOrderNote: false,
      isPayment: false,
      checkProgress: arr,
      isOrderReview: true,
      checkProgressValue: "Order Review",
    });
  };

  setPaymentValue = (val) => {
    console.log("payemeeeeeee", val);
    this.setState({
      paymentType: val
    })
  }

  paymentCardFunction = (val) => {
    console.log(" ", val);
    this.setState({
      paymentCardId: val
    })
  }
  onSubmitPayment = (id) => {

    const { checkProgress, cardId, paymentError } = this.state;
    if (!id) {
      this.state.error.paymentError = "Please select the payment option";
      this.setState({
        error: {
          ...this.state.error,
          paymentError: this.state.error.paymentError,
        },
      });
      return;
    }
    const arr = [...checkProgress];
    arr[2].isChecked = true;
    this.setState({
      isCheckout: false,
      isShipping: false,
      isBilling: false,
      isOrderNote: false,
      isPayment: false,
      isOrderReview: true,
      checkProgress: arr,
      cardId: id,
      checkProgressValue: "Order Review",
    });
  };
  onChangeCheckoutPayload = (type, val) => {
    console.log('checkCardd===>', type, val)
    this.setState({
      checkoutPayload: {
        ...this.state.checkoutPayload,
        [type]: val,
      },
    });
  };

  onSubmitCheckout = () => {
    const { createOrder, storeInfo } = this.props;
    this.props.history.push("/product/shoppingcart/checkout");
    const { placeOrderData, checkoutPayload, rmx_company_id } = this.state;
    const rmxuser = JSON.parse(localStorage.getItem("rmxUser"));
    const selectedCurrency = localStorage.getItem("selectedCurrency");
    this.setState({ currency: selectedCurrency });
    console.log("selectedCurrency in checkout===>", selectedCurrency);
    const isCheckout = JSON.parse(localStorage.getItem("cart"));
    const previousData = isCheckout.map((item) => {
    console.log("isCheckout item===>", item);

    const price = item?.rmx_product_prices?.length
        ? item.rmx_product_prices.find(({ rmx_product_price: i }) => i?.currency === selectedCurrency)
          ?.rmx_product_price?.price || 0
        : selectedCurrency === "$" || selectedCurrency === "USD"
          ? item?.actualProdcutPrice || item?.price || 0
          : 0;

      return {
        // price: item.actualProdcutPrice,
        price: Number(price),
        quantity: item?.quantity,
        rmx_product_id: item?.id,
        order_product_additive: item?.rmx_product_additives
          ?.filter((v) => v?.selected)
          .map((c) => {
            return {
              selected: 1,
              rmx_product_additive_id: c.id,
            };
          }),
      };
    });
    const { purchase_order_num, ...rest } = checkoutPayload;
    console.log("purc#===>", purchase_order_num)

    console.log("Ceckk===>", checkoutPayload)
    const obj = {
      order_product: [...previousData],
      rmx_company_id: storeInfo.id,
      purchase_order_num: purchase_order_num,
      currency: selectedCurrency || "USD",
      ...rest,
    };
    const d = isCheckout.every((item) => item.quantity);
    if (!d) {
      info("error", "Quantity must be greater than zero");
      return;
    }
    // const isCheckQuntity= checkoutPayload
    // checkoutPayload.

    // if (checkoutPayload.zipcode) {
    //   // validaion for purchase order
    //   if (checkoutPayload.zipcode.length > 10) {

    //     this.state.error.purchaseOrderError =
    //       "purchase Order length should be less than 10";
    //     this.setState({
    //       error: {
    //         ...this.state.error,
    //         purchaseOrderError:
    //           this.state.error.purchaseOrderError,
    //       },
    //     });
    //     return;
    //   }
    // }

    if (!checkoutPayload.preferred_delivery_datetime) {
      this.state.error.preferred_delivery_datetimeError =
        "Preferred Date is required";
      this.setState({
        error: {
          ...this.state.error,
          preferred_delivery_datetimeError:
            this.state.error.preferred_delivery_datetimeError,
        },
      });
      return;
    }
    createOrder(obj, () => {
      this.setState({
        isCheckout: true,
        isShopingCart: false,
        ishideCrossIcon: true,
        dateIndex: "",
        preferedTime: "pm",
        paymentType: "credit-purchase",
        paymentCardId: "",
        // checkoutPayload: {
        //   ...this.state.checkoutPayload,
        //   // preferred_delivery_datetime: "",
        //   // purchase_order_num: "",

        // },
      });
    });
    console.log("checkingObj===>", this.state);

  };
  onChangeOrderNote = (e) => {
    console.log("ordeeeeeee", e.target.value);
    this.setState({
      order_note: e.target.value,
    });
  };
  placeOrders = () => {
    const { placeOrder, orderData, creditPurchaseOrder, updateOrder } = this.props;
    const order_note = this.state.order_note

    if (!this.state.cardId) {

      creditPurchaseOrder(
        { contractor_stripe_source_id: this.state.cardId },
        orderData.id,
        () => {
          this.setState({
            checkoutPayload: {
              ...this.state.checkoutPayload,
              preferred_delivery_datetime: "",
              purchase_order_num: "",
            },
            addressPayload: {
              address_type: "",
              contractor_address_id: "",
            },
            billingAddressName: "",
            shippingAddressName: "",
            showBillingAddressField: "",
            showShippingAddressField: "",
            paymentType: "credit-purchase",
            paymentCardId: "",
            cardId: "",
            isOrderReview: false,
            isShopingCart: false,
            isshowAddProduct: false,
            isOrderSuccess: true,
            ishideCrossIcon: false,
            order_note: "",
          });
          window.localStorage.removeItem("cart");
        }
      );

      console.log("ordermeeeeee", this.state.orderDataAddress.length);
      if (this.state.orderDataAddress.length == 0) {
        // debugger
        console.log("bill runnnnn");
        let payload = {
          ...this.state.addressPayload,
          address_type: "billing",
          contractor_address_id: this.state.showBillingAddressField?.value
        }
        this.props.postOrderAddress(payload, orderData.id)
      }
      if (this.state.orderDataAddress.length == 0) {

        let payload = {
          ...this.state.addressPayload,
          address_type: "shipping",
          contractor_address_id: this.state.showShippingAddressField?.value
        }
        this.props.postOrderAddress(payload, orderData.id)
      }

      updateOrder({ order_note }, orderData.id, () => {
      });

      return;
    }

    if (this.state.orderDataAddress.length == 0) {
      let payload = {
        ...this.state.addressPayload,
        address_type: "billing",
        contractor_address_id: this.state.showBillingAddressField?.value
      }
      this.props.postOrderAddress(payload, orderData.id)
    }
    if (this.state.orderDataAddress.length == 0) {
      let payload = {
        ...this.state.addressPayload,
        address_type: "shipping",
        contractor_address_id: this.state.showShippingAddressField?.value
      }
      this.props.postOrderAddress(payload, orderData.id)
    }
    placeOrder(
      { contractor_stripe_source_id: this.state.cardId, order_note },
      orderData.id,
      () => {
        this.setState(
          {
            cart: [],
          },
          () => {
            this.setState({

              checkoutPayload: {
                ...this.state.checkoutPayload,
                preferred_delivery_datetime: "",
                purchase_order_num: "",
              },
              addressPayload: {
                address_type: "",
                contractor_address_id: "",
              },
              orderDataAddress: [],
              billingAddressName: "",
              shippingAddressName: "",
              showBillingAddressField: "",
              showShippingAddressField: "",
              paymentType: "credit-purchase",
              paymentCardId: "",
              cardId: "",
              isOrderReview: false,
              isShopingCart: false,
              isshowAddProduct: false,
              isOrderSuccess: true,
              order_note: "",
            });
            window.localStorage.removeItem("cart");
          }
        );
      }
    );
    updateOrder({ order_note }, orderData.id, () => {
      this.setState({
        checkoutPayload: {
          ...this.state.checkoutPayload,
          preferred_delivery_datetime: "",
          purchase_order_num: "",
        },
        addressPayload: {
          address_type: "",
          contractor_address_id: "",
        },

        orderDataAddress: [],
        billingAddressName: "",
        shippingAddressName: "",
        showBillingAddressField: "",
        showShippingAddressField: "",
        paymentType: "credit-purchase",
        isOrderReview: false,
        isShopingCart: false,
        isshowAddProduct: false,
        isOrderSuccess: true,
        paymentCardId: "",
        cardId: "",
        order_note: ""
      });

    });
  };
  onbackCatalogScreen = () => {
    this.props.history.push("/");
    this.setState({
      isCheckout: false,
      isShipping: false,
      isBilling: false,
      isOrderNote: false,
      isOrderReview: false,
      isPayment: false,
      isShopingCart: false,
      isshowAddProduct: false,
    });
    window.localStorage.removeItem("cart");
  };
  clearError = () => {
    this.setState({
      error: {
        preferred_delivery_datetimeError: "",
        addressError: "",
        paymentError: "",
        purchaseOrderError: "",
      },
    });
  };

  deleteFromCart = (index) => {
    const arr = [...this.state.cart];
    arr.splice(index, 1);
    this.setState({
      cart: arr,
    });
    localStorage?.setItem("cart", JSON.stringify(arr));
  };
  render() {
    console.log("bilnamee", this.state.billingAddressName, this.state.shippingAddressName);
    console.log("paymen parent", this.state.paymentCardId);

    // let bilname = this.state.billingAddressName
    const rmxuser = JSON.parse(localStorage?.getItem("rmxUser"));
    let sum = 0;
    const { products, storeInfo, signin, loader } = this.props;
    const {
      isCheckout,
      isShipping,
      isBilling,
      isOrderNote,
      checkProgress,
      isPayment,
      isOrderReview,
      isShopingCart,
      isShopping,
      cart,
      isshowAddProduct,
      error,
      isOrderSuccess,
      isOpenCard,
      cardDetails,
      authError,

      cardDetailError: { numberError, cvcError, exp_monthError, exp_yearError },
      isShowLoginModal,
      userObj,
      errorObj: { emailError, passwordError },
    } = this.state;

    console.log("manage_history", this.state);

    console.log("checkoutState", !this.state.isCheckout);
    // console.log(cookies.get("contractor_credentials")); // Pacman or undefined if not set yet
    console.log("authRedcuerError", this.props.error, authError);
    const loginMenu = (
      <Menu className="cart-menu">
        <Row justify="start" style={{ width: "100%" }}>
          <Col span={24} className="text-left">
            <h5
              style={{
                fontSize: "20px",
                lineHeight: "15px",
                margin: "0.82rem 0 0.656rem 0",
                color: " #323761",
              }}
            >
              Login Credentials
            </h5>
          </Col>
          <Col span={24} className="text-left">
            <p style={{ color: "#9e9e9e", marginTop: "15px" }}>
              Already Registered? Please Login Below.
            </p>
          </Col>
          <Col span={24} style={{ marginTop: "-15px" }}>
            <Row style={{ width: "100%" }}>
              <Col span={24}>
                <TextInput
                  label="Username"
                  type="email"
                  value={userObj.email}
                  onChange={(e) => {
                    this.setState({
                      userObj: { ...this.state.userObj, email: e.target.value },
                      errorObj: {
                        ...this.state.errorObj,
                        emailError: "",
                      },
                      authError: "",
                    });
                  }}
                />

                <Row>
                  <Col span={24}>
                    <span className="text-right d-grid danger-color">
                      {emailError && emailError}
                    </span>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <TextInput
                  label="Password"
                  type="password"
                  value={userObj.password}
                  onChange={(e) =>
                    this.setState({
                      userObj: {
                        ...this.state.userObj,
                        password: e.target.value,
                      },
                      errorObj: {
                        ...this.state.errorObj,
                        passwordError: "",
                      },
                      authError: "",
                    })
                  }
                />

                <Row>
                  <Col span={24}>
                    <span className="text-right d-grid danger-color">
                      {passwordError && passwordError}
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <span className="text-center d-grid danger-color">
              {authError && authError}
            </span>
          </Col>
          <Col span={24} className="text-left" style={{ margin: "20px 0px" }}>
            <small
              style={{ fontSize: "80%" }}
              className="pointer-cursor"
              onClick={() =>
                window.open(
                  `${process.env.REACT_APP_LINK}://app${process.env.REACT_APP_DOMAIN}/#/customer/forgot`
                )
              }
            >
              Forgot Password?
            </small>
          </Col>
          <Col span={24}>
            <Row align="middle" justify="space-between" gutter={[10, 0]}>
              <Col span={12} className="pointer-cursor">
                <Button
                  style={{
                    backgroundColor: "#f9a01b",
                    color: "#fff",
                    border: "none",
                    width: "100%",
                  }}
                  onClick={() => {
                    if (
                      !userObj.email.trim().length ||
                      !userObj.password.trim().length
                    ) {
                      if (!userObj.email.trim().length) {
                        this.state.errorObj.emailError =
                          "Username is required.";
                      }
                      if (!userObj.password.trim().length) {
                        this.state.errorObj.passwordError =
                          "Password is required.";
                      }
                      this.setState({ errorObj: this.state.errorObj });
                      return;
                    }
                    signin(userObj, () =>
                      this.setState({
                        isShowLoginModal: false,
                        userObj: { email: "", password: "" },
                      })
                    );
                  }}
                >
                  LOGIN
                </Button>
                {/* {loader && <img src={LoaderGif} height={"60"} width={"60"} />} */}
              </Col>
              <Col span={12} className="pointer-cursor">
                <Button
                  style={{
                    backgroundColor: "#00796b",
                    color: "#fff",
                    width: "100%",
                    border: "none",
                  }}
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_LINK}://app${process.env.REACT_APP_DOMAIN}/#/customer/register`
                    )
                  }
                >
                  REGISTER
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Menu>
    );

    const menu = (
      <Menu className=" cart-menu ant-dropdown-menu-add-to-cart">
        <Row
          justify="start"
          className="pointer-cursor "
          style={{ borderBottom: "1px solid #edeff0", padding: "0.7rem" }}
        >
          <Col span={24}>
            {(cart || []).map((item, index) => {
              // sum = Number(item.price) + sum;
              sum = item?.selectedAditivePrice
                ? Number(
                  (item?.selectedAditivePrice + item?.actualProdcutPrice) *
                  item?.quantity
                )
                : Number(item?.quantity * item?.actualProdcutPrice);
              return (
                <>
                  <Row style={{ marginBottom: "30px", width: "100%" }}>
                    <Col
                      xl={4}
                      lg={2}
                      md={2}
                      xs={4}
                      sm={4}
                      style={{
                        backgroundImage: `url(${item?.image?.original})`,
                        height: "52px",
                        width: " 52px",
                        backgroundPosition: "center center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        margin: "0px",
                      }}
                    ></Col>
                    <Col xl={20} lg={20} md={20} xs={20} sm={20}>
                      <Row
                        justify="start"
                        style={{
                          paddingLeft: "10px",
                        }}
                        align="middle"
                      >
                        <Col
                          xl={24}
                          lg={24}
                          md={24}
                          xs={24}
                          sm={24}
                          className="text-left checkout-text"
                        >
                          <span
                            style={{ fontSize: "1.2rem", fontWeight: "600" }}
                          >
                            {item?.name}
                          </span>
                        </Col>
                        <Col
                          xl={20}
                          lg={20}
                          md={20}
                          xs={20}
                          sm={20}
                          className="text-left"
                        >
                          {/* {`$${item.price} x ${item?.quantity}${item?.unit}`} */}
                          <span
                            style={{ color: "#09c1b2", fontSize: "100%" }}
                            className="text-left"
                          >
                            {`$${numberWithCommas(
                              Number(
                                item?.actualProdcutPrice +
                                item?.selectedAditivePrice
                              ).toFixed(2)
                            )}`}
                          </span>
                          <small
                            style={{
                              padding: "5px",
                              fontSize: "100%",
                              color: "#09c1b2",
                            }}
                          >
                            X
                          </small>
                          <small
                            style={{
                              padding: "5px",
                              fontSize: "100%",
                              color: "#09c1b2",
                            }}
                          >
                            {item.quantity}
                            {item?.unit}
                          </small>
                        </Col>
                        <Col
                          xl={4}
                          lg={4}
                          md={4}
                          xs={4}
                          sm={4}
                          className="text-right"
                          onClick={() => {
                            const abc = [...cart];
                            abc.splice(index, 1);
                            this.setState({
                              cart: abc,
                            });
                            localStorage.setItem("cart", JSON.stringify(abc));
                          }}
                        >
                          {!this.state.ishideCrossIcon && (
                            <img
                              src={CrossIcom}
                              className="cross-img pointer-cursor"
                            />

                          )}

                        </Col>
                      </Row>
                    </Col>
                    {/* <Col span={24} style={{ marginTop: '5px' }}>
                      <Divider />
                    </Col> */}
                  </Row>
                </>
              );
            })}
          </Col>
        </Row>

        <Col style={{ borderBottom: "1px solid #edeff0", padding: "0.7rem" }}>
          <Row justify="end">
            <Col span={24} className="text-right" style={{ marginTop: "7px" }}>
              <span style={{ color: "#9e9e9e" }}>TOTAL</span>
            </Col>
            <Col
              span={24}
              className="text-right"
              style={{
                fontSize: "20px",
                lineHeight: "30px",
                margin: "0.82rem 0 0.656rem 0",
                color: "#323761",
              }}
            >
              {/* <span>${sum}</span> */}$
              {numberWithCommas(
                Number(
                  (cart || []).reduce((pre, item) => {
                    return item?.selectedAditivePrice
                      ? Number(pre) +
                      Number(
                        (item?.selectedAditivePrice +
                          item?.actualProdcutPrice) *
                        item.quantity
                      )
                      : Number(pre) +
                      Number(item.quantity * item.actualProdcutPrice);
                    // // Number(item.price * item.quantity)
                  }, 0)
                ).toFixed(2)
              )}
            </Col>
          </Row>
        </Col>
        <Col
          style={{ marginTop: "10px", marginBottom: "7px", padding: "0.7rem" }}
        >
          <Row justify="end">
            <Col span={8}>
              <Button
                style={{
                  backgroundColor: "#26a69a",
                  color: "#fff",
                  border: "none",
                }}
                onClick={() => {
                  this.props.history.push("/product/shoppingcart");
                  this.setState({
                    isShopingCart: true,
                    isshowAddProduct: true,
                    isCheckout: false,
                    isShipping: false,
                    isBilling: false,
                    isOrderNote: false,
                    isOrderReview: false,
                    isPayment: false,
                    isShopping: false,
                    keyTab: 1,
                    checkProgress: [
                      {
                        name: "Billing Address",
                        isChecked: false,
                      },
                      {
                        name: "Shipping Address",
                        isChecked: false,
                      },
                      // {
                      //   name: "Order Notes",
                      //   isChecked: false,
                      // },
                      {
                        name: "Payment Method",
                        isChecked: false,
                      },
                      {
                        name: "Order Review",
                        isChecked: false,
                      },
                    ],
                    checkProgressValue: "Billing Address",
                    // addressPayload: {
                    //   address_type: "",
                    //   contractor_address_id: "",
                    // },
                    // dateIndex: "",
                    // preferedTime: "am",
                  });
                }}
              >
                GO TO CART
              </Button>
            </Col>
          </Row>
        </Col>
      </Menu>
    );

    console.log("storeUrl==>", storeInfo);
    console.log("props_history", this.props.history);
    return (
      <Row justify="center">
        <Col
          xl={24}
          lg={24}
          md={24}
          xs={24}
          sm={24}
          style={{ marginBottom: "20px" }}
        >
          <Row>
            <Col
              span={24}
              className="rmx-profile-cover"
              style={{
                backgroundImage: `url(${storeInfo?.rmx_company_asset?.cover?.original})`,
              }}
            >
              <Row>
                <Col
                  xl={6}
                  lg={6}
                  md={6}
                  xs={18}
                  sm={18}
                  className="rmx-profile-img-container"
                >
                  <Row>
                    <Col
                      xl={24}
                      className="rmx-circle-profile-image"
                      id="preview-logo"
                      style={{
                        backgroundImage: `url(${storeInfo?.rmx_company_asset?.logo?.original})`,
                      }}
                    ></Col>
                  </Row>
                </Col>
                <Col
                  xl={17}
                  xxl={17}
                  lg={17}
                  md={17}
                  sm={17}
                  xs={17}
                  style={{
                    height: "40vh",
                    position: "relative",
                  }}
                >
                  <Row
                    align="bottom"
                    justify="start"
                    className="rmx-profile-name-container"
                  >
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                      <h4 className="white-text text-left" id="profile-name">
                        {storeInfo?.rmx_company_asset?.store_name}
                      </h4>
                    </Col>
                    <Row justify="end">
                      <Col
                        xxl={24}
                        xl={24}
                        lg={24}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ position: "absolute" }}
                        className="rmx-profile-cart-options"
                      >
                        <Row
                          align="middle"
                          justify="center"
                          style={{
                            justifyContent: "start",
                          }}
                          className="pointer-cursor"
                        >
                          <Col
                            style={{
                              backgroundColor: "#314047",
                              padding: "5px",
                            }}
                            onClick={() =>
                              window.open(
                                `${process.env.REACT_APP_LINK}://app${process.env.REACT_APP_DOMAIN}/#/customer/dashboard`
                              )
                            }
                            className="pointer-cursor"
                          >
                            <span>
                              <img
                                src={personCartIcon}
                                width="12"
                                className="pointer-cursor"
                                style={{ marginTop: "-4.5px" }}
                              />
                              {/* <IoPersonSharp
                                fontSize="small"
                                color="#fff"
                                className="pointer-cursor"
                              /> */}
                            </span>
                            <span
                              style={{
                                color: "#fff",
                                display: "inline",
                                paddingLeft: "8px",
                                fontSize: "0.9rem",
                              }}
                            >
                              {cookies.get("contractor_credentials")
                                ? JSON.parse(
                                  window.localStorage.getItem(
                                    "trkr_contractor_auth"
                                  )
                                )?.[0]?.user?.first_name
                                : "Account"}
                            </span>
                            <span
                              style={{
                                color: "#fff",
                                display: "inline",
                                paddingLeft: "8px",
                                fontSize: "0.9rem",
                              }}
                            >
                              {cookies.get("contractor_credentials")
                                ? JSON.parse(
                                  window.localStorage.getItem(
                                    "trkr_contractor_auth"
                                  )
                                )?.[0]?.user?.last_name
                                : ""}
                            </span>
                          </Col>
                          <Col
                            style={{
                              backgroundColor: "#314047",
                              padding: "5px",
                            }}
                          >
                            <Dropdown
                              overlay={
                                !cookies.get("contractor_credentials") ? (
                                  loginMenu
                                ) : !!this.state.cart?.length ? (
                                  menu
                                ) : (
                                  <></>
                                )
                              }
                              placement="bottomLeft"
                              arrow={!!this.state.cart?.length}
                            >
                              <Row justify="center" align="middle">
                                <Col
                                  style={{
                                    backgroundColor: "#314047",
                                  }}
                                >
                                  <Badge
                                    className="rmx-count"
                                    count={
                                      JSON.parse(
                                        window.localStorage.getItem("cart")
                                      )?.length
                                    }
                                    style={{ backgroundColor: "#f9a01b" }}
                                    size="small"
                                    offset={[1, -1]}
                                    showZero
                                  >
                                    <span>
                                      <img
                                        src={bucketCartIcon}
                                        width="12"
                                        style={{ marginTop: "-4px" }}
                                      />
                                      {/* <AiOutlineShoppingCart
                                        color="#fff"
                                        className="pointer-cursor"
                                        size={14}
                                      /> */}
                                    </span>
                                  </Badge>
                                  <span
                                    style={{
                                      color: "#fff",
                                      display: "inline",
                                      paddingLeft: "8px",
                                      fontSize: "0.9rem",
                                    }}
                                  >
                                    Cart
                                  </span>
                                </Col>
                              </Row>
                            </Dropdown>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="center" style={{ marginTop: "5px" }}>
            <Col xl={20} sm={24} xs={24} md={24} lg={24}>
              {isshowAddProduct && (
                <Row justify="start">
                  <Col
                    xl={7}
                    xxl={7}
                    lg={7}
                    style={{ marginLeft: "-14px" }}
                  ></Col>
                  <Col
                    xl={17}
                    lg={17}
                    xs={24}
                    sm={24}
                    md={16}
                    xxl={17}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                    }}
                    className="text-left"
                  >
                    <span
                      className="pointer-cursor text-left"
                      style={{
                        fontSize: "14px",
                        color: "#444",
                        marginLeft: "-15px",
                      }}
                    >
                      {isshowAddProduct &&
                        !isShopingCart &&
                        !isCheckout &&
                        !isShipping &&
                        !isBilling &&
                        !isOrderNote &&
                        !isPayment &&
                        !isOrderReview && (
                          <Row justify="start">
                            <Col span={24} className="text-left">
                              <span className="text-left">
                                <span
                                  style={{
                                    marginRight: "28px",
                                  }}
                                  className="text-left"
                                  onClick={() => {
                                    this.setState({
                                      isCheckout: false,
                                      isShipping: false,
                                      isBilling: false,
                                      isOrderNote: false,
                                      isOrderReview: false,
                                      isPayment: false,
                                      isShopingCart: false,
                                      isshowAddProduct: false,
                                      orderDataAddress: []
                                      // addressPayload: {
                                      //   address_type: "",
                                      //   contractor_address_id: "",
                                      // },
                                      // ishideCrossIcon: false,
                                      // checkProgress: [
                                      //   {
                                      //     name: "Billing Address",
                                      //     isChecked: false,
                                      //   },
                                      //   {
                                      //     name: "Shipping Address",
                                      //     isChecked: false,
                                      //   },
                                      //   // {
                                      //   //   name: "Order Notes",
                                      //   //   isChecked: false,
                                      //   // },
                                      //   {
                                      //     name: "Payment Method",
                                      //     isChecked: false,
                                      //   },
                                      //   {
                                      //     name: "Order Review",
                                      //     isChecked: false,
                                      //   },
                                      // ],
                                      // checkProgressValue: "Billing Address",
                                      // preferedTime: 'pm',
                                      // checkoutPayload: {
                                      //   ...this.state.checkoutPayload,
                                      //   // purchase_order_num: "",
                                      //   // preferred_delivery_datetime: "",
                                      //   preferred_delivery_period: "pm",
                                      // },
                                    });
                                    this.props.history.push("/");
                                    this.clearError();
                                  }}
                                >
                                  Home
                                </span>
                                <span
                                  style={{
                                    fontSize: "0.7rem",
                                  }}
                                >{`>`}</span>
                                <span
                                  className="st-primary"
                                  style={{ paddingLeft: "20px" }}
                                >
                                  {this.state.addproduct.name}
                                </span>
                              </span>
                            </Col>
                          </Row>
                        )}
                      {isShopingCart && (
                        <Row justify="start">
                          <Col span={24} className="text-left">
                            <span className="text-left">
                              <span
                                style={{
                                  marginRight: "12px",
                                }}
                                className="text-left"
                                onClick={() => {
                                  this.setState({
                                    isCheckout: false,
                                    isShipping: false,
                                    isBilling: false,
                                    isOrderNote: false,
                                    isOrderReview: false,
                                    isPayment: false,
                                    isShopingCart: false,
                                    isshowAddProduct: false,
                                    orderDataAddress: []
                                    // addressPayload: {
                                    //   address_type: "",
                                    //   contractor_address_id: "",
                                    // },

                                    // ishideCrossIcon: false,
                                    // checkProgress: [
                                    //   {
                                    //     name: "Billing Address",
                                    //     isChecked: false,
                                    //   },
                                    //   {
                                    //     name: "Shipping Address",
                                    //     isChecked: false,
                                    //   },
                                    //   // {
                                    //   //   name: "Order Notes",
                                    //   //   isChecked: false,
                                    //   // },
                                    //   {
                                    //     name: "Payment Method",
                                    //     isChecked: false,
                                    //   },
                                    //   {
                                    //     name: "Order Review",
                                    //     isChecked: false,
                                    //   },
                                    // ],
                                    // checkProgressValue: "Billing Address",
                                    // preferedTime: 'pm',
                                    // checkoutPayload: {
                                    //   ...this.state.checkoutPayload,
                                    //   // purchase_order_num: "",
                                    //   // preferred_delivery_datetime: "",
                                    //   preferred_delivery_period: "pm",
                                    // },
                                  });
                                  this.props.history.replace("/");
                                  this.clearError();
                                }}
                              >
                                Home
                              </span>
                              <span
                                style={{
                                  fontSize: "0.7rem",
                                }}
                              >{`>`}</span>
                              <span
                                className="st-primary"
                                onClick={() => {
                                  this.setState({
                                    isCheckout: false,
                                    isShipping: false,
                                    isBilling: false,
                                    isOrderNote: false,
                                    isOrderReview: false,
                                    isPayment: false,
                                    isShopingCart: true,
                                    checkProgress: [
                                      {
                                        name: "Billing Address",
                                        isChecked: false,
                                      },
                                      {
                                        name: "Shipping Address",
                                        isChecked: false,
                                      },
                                      // {
                                      //   name: "Order Notes",
                                      //   isChecked: false,
                                      // },
                                      {
                                        name: "Payment Method",
                                        isChecked: false,
                                      },
                                      {
                                        name: "Order Review",
                                        isChecked: false,
                                      },
                                    ],
                                    checkProgressValue: "Billing Address",
                                    // addressPayload: {
                                    //   address_type: "",
                                    //   contractor_address_id: "",
                                    // },
                                    ishideCrossIcon: false,
                                    preferedTime: "pm",
                                    checkoutPayload: {
                                      ...this.state.checkoutPayload,
                                      // purchase_order_num: "",
                                      // preferred_delivery_datetime: "",
                                      preferred_delivery_period: "pm",
                                    },
                                  });
                                  this.props.history.push(
                                    "/product/shoppingcart"
                                  );
                                }}
                                style={{ paddingLeft: "20px" }}
                              >
                                Shopping cart
                              </span>
                            </span>
                          </Col>
                        </Row>
                      )}
                      {/* {isShopingCart && (
                        <span
                          className=" pointer-cursor text-left"
                          style={{
                            fontSize: "14px",
                            color: "#444",
                          }}
                        >
                          <Row justify="start" className="text-left">
                            <Col
                              span={24}
                              className="text-left"
                              style={{
                                border: "1px solid red",
                                marginRight: "28px",
                              }}
                            >
                              <span className="text-left">
                                <span
                                  className="text-left"
                                  onClick={() =>
                                    this.setState({
                                      isCheckout: false,
                                      isShipping: false,
                                      isOrderNote: false,
                                      isOrderReview: false,
                                      isPayment: false,
                                      isShopingCart: false,
                                      isshowAddProduct: false,
                                    })
                                  }
                                >
                                  {" "}
                                  Home
                                </span>
                                <span
                                  style={{
                                    fontSize: "0.7rem",
                                    marginLeft: "10px",
                                  }}
                                >{`>`}</span>
                                <span
                                  className="st-primary"
                                  onClick={() =>
                                    this.setState({
                                      isCheckout: false,
                                      isShipping: false,
                                      isOrderNote: false,
                                      isOrderReview: false,
                                      isPayment: false,
                                      isShopingCart: false,
                                      isshowAddProduct: false,
                                    })
                                  }
                                  style={{ paddingLeft: "20px" }}
                                >
                                  Shopping cart{" "}
                                </span>{" "}
                              </span>
                            </Col>
                          </Row>
                        </span>
                      )} */}
                      {(isCheckout ||
                        isShipping ||
                        isBilling ||
                        isOrderNote ||
                        isPayment ||
                        isOrderReview) && (
                          <span className="text-left">
                            {" "}
                            <span
                              onClick={() => {
                                this.clearError();

                                this.setState({
                                  isCheckout: false,
                                  isShipping: false,
                                  isBilling: false,
                                  isOrderNote: false,
                                  isOrderReview: false,
                                  isPayment: false,
                                  isShopingCart: false,
                                  isshowAddProduct: false,
                                  orderDataAddress: []
                                  // addressPayload: {
                                  //   address_type: "",
                                  //   contractor_address_id: "",
                                  // },
                                  // ishideCrossIcon: false,
                                  // checkProgress: [
                                  //   {
                                  //     name: "Billing Address",
                                  //     isChecked: false,
                                  //   },
                                  //   {
                                  //     name: "Shipping Address",
                                  //     isChecked: false,
                                  //   },
                                  //   // {
                                  //   //   name: "Order Notes",
                                  //   //   isChecked: false,
                                  //   // },
                                  //   {
                                  //     name: "Payment Method",
                                  //     isChecked: false,
                                  //   },
                                  //   {
                                  //     name: "Order Review",
                                  //     isChecked: false,
                                  //   },
                                  // ],
                                  // checkProgressValue: "Billing Address",
                                  // preferedTime: 'pm',
                                  // checkoutPayload: {
                                  //   ...this.state.checkoutPayload,
                                  //   // purchase_order_num: "",
                                  //   // preferred_delivery_datetime: "",
                                  //   preferred_delivery_period: "pm",
                                  // },
                                });
                                this.props.history.replace("/plantowner");
                                this.clearError();
                              }}
                            >
                              Home
                            </span>
                            <span
                              style={{
                                fontSize: "0.7rem",
                                marginLeft: "8px",
                              }}
                            >{`>`}</span>
                            <span
                              onClick={() => {
                                this.setState({
                                  isCheckout: false,
                                  isShipping: false,
                                  isBilling: false,
                                  isOrderNote: false,
                                  isOrderReview: false,
                                  isPayment: false,
                                  isShopingCart: true,
                                  orderDataAddress: []
                                  // checkProgress: [
                                  //   {
                                  //     name: "Billing Address",
                                  //     isChecked: false,
                                  //   },
                                  //   {
                                  //     name: "Shipping Address",
                                  //     isChecked: false,
                                  //   },
                                  //   // {
                                  //   //   name: "Order Notes",
                                  //   //   isChecked: false,
                                  //   // },
                                  //   {
                                  //     name: "Payment Method",
                                  //     isChecked: false,
                                  //   },
                                  //   {
                                  //     name: "Order Review",
                                  //     isChecked: false,
                                  //   },
                                  // ],
                                  // checkProgressValue: "Billing Address",
                                  // addressPayload: {
                                  //   address_type: "",
                                  //   contractor_address_id: "",
                                  // },
                                  // billingAddressName: "",
                                  // shippingAddressName: "",
                                  // showBillingAddressField: "",
                                  // showShippingAddressField: "",
                                  // ishideCrossIcon: false,
                                  // preferedTime: 'pm',
                                  // checkoutPayload: {
                                  //   ...this.state.checkoutPayload,
                                  //   // purchase_order_num: "",
                                  //   // preferred_delivery_datetime: "",
                                  //   preferred_delivery_period: "pm",
                                  // },

                                });
                                this.props.history.push(
                                  "/plantowner/product/shoppingcart"
                                );
                              }}
                              style={{
                                marginLeft: "8px",
                              }}
                            >
                              Shopping cart
                            </span>
                            <span
                              style={{
                                fontSize: "0.7rem",
                                marginLeft: "8px",
                              }}
                            >{`>`}</span>
                            {/* <span
                              // className="st-primary"
                              style={{
                                marginLeft: "8px",
                              }}
                            >
                              Checkout
                            </span>


                            <span
                              style={{
                                fontSize: "0.7rem",
                                marginLeft: "8px",
                              }}
                            >{`>`}</span> */}
                            {/* {console.log("isbill", isBilling)} */}
                            <span
                              className={isCheckout == true ? `st-primary` : ""}
                              onClick={() => this.moveBackAndForward(0, { name: "Billing Address", isChecked: this.state?.checkProgress[0]?.isChecked })}
                              style={{
                                marginLeft: "8px",
                              }}
                            >
                              Billing Address
                            </span>


                            <span
                              style={{
                                fontSize: "0.7rem",
                                marginLeft: "8px",
                              }}
                            >{`>`}</span>
                            <span
                              className={isShipping == true ? `st-primary` : ""}
                              onClick={() => this.moveBackAndForward(1, { name: "Shipping Address", isChecked: this.state.checkProgress[1].isChecked })}
                              style={{
                                marginLeft: "8px",
                              }}
                            >
                              Shipping Address
                            </span>

                            <span
                              style={{
                                fontSize: "0.7rem",
                                marginLeft: "8px",
                              }}
                            >{`>`}</span>
                            <span
                              className={isPayment == true ? `st-primary` : ""}
                              onClick={() => this.moveBackAndForward(2, { name: "Payment Method", isChecked: this.state.checkProgress[2].isChecked })}
                              style={{
                                marginLeft: "8px",
                              }}
                            >
                              Payment Method
                            </span>


                            <span
                              style={{
                                fontSize: "0.7rem",
                                marginLeft: "8px",
                              }}
                            >{`>`}</span>
                            <span
                              className={isOrderReview == true ? `st-primary` : ""}
                              onClick={() => this.moveBackAndForward(2, { name: "Order Review" })}
                              style={{
                                marginLeft: "8px",
                              }}
                            >
                              Order Review
                            </span>
                          </span>
                        )}
                    </span>
                  </Col>
                </Row>
              )}



              {!isshowAddProduct &&
                !isOrderSuccess &&
                !isShopingCart &&
                !isCheckout &&
                !isShipping &&
                !isBilling &&
                !isOrderNote &&
                !isPayment &&
                !isOrderReview && (
                  <Row justify="start" gutter={[20, 0]}>
                    <Col
                      xl={6}
                      xxl={6}
                      lg={6}
                      style={{ marginLeft: "-14px" }}
                    ></Col>
                    <Col
                      xl={13}
                      lg={11}
                      md={8}
                      sm={8}
                      xs={8}
                      xll={13}
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        left: "20px",
                      }}
                    >
                      <span
                        className={
                          this.state.keyTab === 1
                            ? "rmx-catalog  pointer-cursor"
                            : "rmx-catalog-hover  pointer-cursor"
                        }
                        style={{
                          fontSize: "1.1rem",
                          borderBottom:
                            this.state.keyTab === 1
                              ? "solid 3px #00bfa5"
                              : "none",
                          marginBottom: "10px",
                        }}
                        onClick={() => {
                          this.setState({
                            keyTab: 1,
                          });
                          this.props.history.push("");
                        }}
                      >
                        Catalog
                      </span>
                      <span
                        className={
                          this.state.keyTab === 2
                            ? "rmx-catalog  pointer-cursor"
                            : "rmx-catalog-hover  pointer-cursor"
                        }
                        style={{
                          fontSize: "1.1rem",
                          borderBottom:
                            this.state.keyTab === 2
                              ? "solid 3px #00bfa5"
                              : "none",
                          paddingBottom: "6px",
                          marginBottom: "10px",
                          marginLeft: "15px",
                        }}
                        onClick={() => {
                          this.setState({
                            keyTab: 2,
                          });
                          this.props.history.push("/aboutus");
                        }}
                      >
                        About Us
                      </span>
                    </Col>

                    {this.state.keyTab === 1 && (
                      <Col
                        span={this.state.keyTab === 1 && 5}
                        xl={this.state.keyTab === 1 && 5}
                        style={{
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        {!this.state.isshowAddProduct && (
                          <Input
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              fontSize: "1rem",
                            }}
                            placeholder="Search..."
                            prefix={
                              <AiOutlineSearch size={20} color="d3d3d3" />
                            }
                            className="rmx-input"
                            onChange={(e) =>
                              this.onFilterSearch(e.target.value)
                            }
                          />
                        )}
                      </Col>
                    )}
                  </Row>
                )}
              {this.state.keyTab === 1 && (
                <Row justify="start">
                  {!isCheckout &&
                    !isShipping &&
                    !isBilling &&
                    !isOrderNote &&
                    !isPayment &&
                    !isOrderReview &&
                    !isShopingCart &&
                    !isOrderSuccess && (
                      <Col
                        xl={6}
                        lg={6}
                        xs={24}
                        sm={24}
                        md={24}
                        style={{ marginTop: "3.5rem" }}
                      >
                        <Category
                          abc={this.abc}
                          isImageTrue={true}
                          categorey={this.props.categories}
                          categoryName={this.state.categoryName}
                          {...this.props}
                        />
                      </Col>
                    )}
                  {(isCheckout ||
                    isShipping ||
                    isBilling ||
                    isOrderNote ||
                    isPayment ||
                    isOrderReview) && (
                      <Col xl={6} lg={6} xs={24} sm={6} md={6}>
                        <CheckoutProgress
                          isImageTrue={true}
                          StorePreview={true}
                          checkProgress={checkProgress}
                          checkoutValue={this.state.checkProgressValue}
                          moveBackAndForward={this.moveBackAndForward}
                          {...this.props}
                        />
                      </Col>
                    )}

                  {!this.state.isshowAddProduct &&
                    !isCheckout &&
                    !isShipping &&
                    !isBilling &&
                    !isOrderNote &&
                    !isPayment &&
                    !isOrderReview &&
                    !isOrderSuccess &&
                    !isShopingCart && (
                      <Col
                        xl={18}
                        lg={18}
                        xs={24}
                        sm={24}
                        md={24}
                        style={{ paddingLeft: "10px", marginTop: "3rem" }}
                      >
                        <CatalogCard
                          {...this.props}
                          categoryName={this.state.categoryName}
                          onChangeFilter={this.onChangeFilter}
                          onChangeShowingFilter={this.onChangeShowingFilter}
                          metaData={this.state.filters}
                          currentPage={this.currentPage}
                          previousPage={this.previousPage}
                          updateProductPrice={this.props.updateProduct}
                          onUpdateProductPrice={this.onUpdatePrice}
                          value={this.state.price}
                          onOpenModal={(e) => this.setState({ price: e })}
                          fromNewCatalog={true}
                          NewCatalogInput={true}
                          postProduct={this.props.postProduct}
                          isProductLoading={this.props.isAddingProduct}
                          iscardTrue={true}
                          addproductData={this.addproductData}
                          isshowAddProduct={() => {
                            if (cookies.get("contractor_credentials")) {
                              this.setState({
                                isshowAddProduct: true,
                              });
                              this.props.history.push("/product");
                            } else {
                              this.setState({
                                isShowLoginModal: true,
                                authError: "",
                              });
                            }
                          }}
                        />
                      </Col>
                    )}
                  {isCheckout && (
                    <Col xl={17} lg={17} xs={24} sm={18} md={17}>
                      <CheckoutCard
                        mainHeading="Checkout"
                        heading={"Billing Address"}
                        type={"billing"}
                        onChangeAddress={this.onChangeAddress}
                        onSubmitAddress={this.onSubmitAddress}
                        showBillingAddressField={this.state.showBillingAddressField}
                        error={this.state.error.addressError}
                        clearError={this.clearError}
                      />
                    </Col>
                  )}

                  {isShopingCart && (
                    <Col xl={24} lg={24} xs={24} sm={24} md={24}>
                      <Row justify="end">
                        <Col span={18}>
                          <ShoppingCart
                            description={this.state.order_note}
                            billAddress={this.state.billingAddressName}
                            shippAddress={this.state.shippingAddressName}
                            orderNoteGet={this.onChangeOrderNote}
                            onbackCatalogScreen={this.onbackCatalogScreen}
                            isShopingCart={isShopingCart}
                            // productData={this.state.addproduct}
                            productData={this.state.cart}
                            totalPrice={this.state.totalPrice}
                            quantity={this.state.quntity}
                            onAchDisable={this.onAchDisable}
                            onChangeCheckoutPayload={
                              this.onChangeCheckoutPayload
                            }
                            checkoutPayload={this.state.checkoutPayload}
                            counter={this.state.counter}
                            onChangeCartQuantity={(e, index) => {
                              const arr = [...this.state.cart];
                              let orderData = [...this.state.placeOrderData];
                              if (orderData?.length) {
                                orderData[index]["quantity"] = e;
                              }
                              if (arr?.length) {
                                arr[index]["quantity"] = e;
                              }
                              const updateLocalStorage = [
                                ...JSON.parse(localStorage.getItem("cart")),
                              ];
                              updateLocalStorage[index]["quantity"] = e;
                              this.setState({
                                cart: arr,
                                placeOrderData: orderData,
                                // quantityArr: qArr,
                                // priceArr: pArr,
                              });
                              // localStorage.setItem('image', 'myCat.png');
                              console.log(
                                "updatedLocalStorage",
                                updateLocalStorage
                              );
                              localStorage.setItem(
                                "cart",
                                JSON.stringify(updateLocalStorage)
                              );
                            }}
                            onSubmitCheckout={this.onSubmitCheckout}
                            preferred_delivery_datetimeError={
                              this.state.error.preferred_delivery_datetimeError
                            }
                            purchaseOrderError={
                              this.state.error.purchaseOrderError
                            }
                            clearError={this.clearError}
                            rmxuser={storeInfo}
                            deleteFromCart={this.deleteFromCart}
                            dateIndex={this.state.dateIndex}
                            setDateIndex={(e) =>
                              this.setState({ dateIndex: e })
                            }
                            preferedTime={this.state.preferedTime}
                            setPreferedTime={(e) => {
                              this.setState({ preferedTime: e });

                              const data = JSON.parse(
                                localStorage?.getItem("cart")
                              );

                              const previousData = data.map((item) => {
                                return {
                                  price: item.actualProdcutPrice,
                                  quantity: item?.quantity,
                                  rmx_product_id: item?.id,
                                  order_product_additive:
                                    item?.rmx_product_additives
                                      ?.filter((v) => v?.selected)
                                      .map((c) => {
                                        return {
                                          selected: 1,
                                          rmx_product_additive_id: c.id,
                                        };
                                      }),
                                };
                              });

                              let Obj = {
                                order_product: [...previousData],
                                preferred_delivery_datetime: "",
                                preferred_delivery_period: e,
                                rmx_company_id: rmxuser?.id,
                                purchase_order_num: "",
                              };
                              this.props.orderPrice(Obj);

                              console.log("previousData==>", Obj);
                            }}
                            orderPrice={this.props.orderPrice}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}

                  {isOrderSuccess && (
                    <Col
                      xl={17}
                      lg={17}
                      xs={24}
                      sm={24}
                      md={24}
                      style={{ margin: "auto" }}
                    >
                      <Row justify="end">
                        <Col span={24}>
                          <OrderSuccess
                            backToCatalog={() => {
                              this.props.history.replace("/");

                              this.setState({
                                isOrderReview: false,
                                isShopingCart: false,
                                isshowAddProduct: false,
                                isOrderSuccess: false,
                                checkProgressValue: "Billing Address",
                                placeOrderData: [],

                                checkProgress: [
                                  {
                                    name: "Billing Address",
                                    isChecked: false,
                                  },
                                  {
                                    name: "Shipping Address",
                                    isChecked: false,
                                  },
                                  // {
                                  //   name: "Order Notes",
                                  //   isChecked: false,
                                  // },
                                  {
                                    name: "Payment Method",
                                    isChecked: false,
                                  },
                                  {
                                    name: "Order Review",
                                    isChecked: false,
                                  },
                                ],
                                dateIndex: "",
                                preferedTime: "pm",
                              });
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}

                  {isShipping && (
                    <Col xl={17} lg={17} xs={24} sm={18} md={20}>
                      <CheckoutCard
                        mainHeading={"Checkout"}
                        heading={"Shipping Address"}
                        type={"shipping"}
                        onChangeAddress={this.onChangeAddress}
                        onSubmitAddress={this.onSubmitShipAddress}
                        showShippingAddressField={this.state.showShippingAddressField}
                        error={this.state.error.addressError}
                        clearError={this.clearError}
                      />
                      {/* <PaymentCard /> */}
                    </Col>
                  )}
                  {isOrderNote && (
                    <Col
                      // xl={18} lg={18} xs={24} sm={24} md={24}
                      xl={17}
                      lg={17}
                      xs={24}
                      sm={18}
                      md={17}
                    >
                      <OrderNoteCard
                        mainHeading={"Checkout"}
                        onSubmitNote={this.onSubmitNote}
                        onChangeOrderNote={this.onChangeOrderNote}
                        order_note={this.state.order_note}
                      />
                    </Col>
                  )}
                  {isPayment && (
                    <Col
                      //  xl={17} lg={17} xs={24} sm={24} md={24}
                      xl={17}
                      lg={17}
                      xs={24}
                      sm={18}
                      md={17}
                    >
                      <PaymentCard
                        mainHeading={"Checkout"}
                        paymentType={this.setPaymentValue}
                        paymentTypeValue={this.state.paymentType}
                        paymentCardFunction={this.paymentCardFunction}
                        paymentCardId={this.state.paymentCardId}
                        clearError={this.clearError}
                        onSubmitPayment={this.onSubmitPayment}
                        onCreditPurchase={this.onCreditPurchase}
                        error={this.state.error.paymentError}
                        orderData={this.props.orderData}
                        isCardLoading={this.props.isCardLoading}
                        isCardReqLoading={this.props.isCardReqLoading}
                        isAchDisable={this.state.isAchDisable}
                        storeInfo={this.props?.storeInfo}
                        isOpenCard={() =>
                          this.setState({
                            isOpenCard: true,
                            cardDetailError: {
                              numberError: "",
                              exp_monthError: "",
                              exp_yearError: "",
                              cvcError: "",
                            },
                            cardDetails: {
                              number: "",
                              exp_month: "",
                              exp_year: "",
                              cvc: "",
                            },
                          })
                        }
                      />
                    </Col>
                  )}
                  {isOrderReview && (
                    <Col
                      // xl={17} lg={17} xs={24} sm={24} md={24}
                      xl={17}
                      lg={17}
                      xs={24}
                      sm={18}
                      md={17}
                    >
                      <ShoppingCart
                        billAddress={this.state.billingAddressName}
                        shippAddress={this.state.shippingAddressName}
                        isShopingCart={isShopingCart}
                        productData={this.state.cart}
                        totalPrice={this.state.totalPrice}
                        quantity={this.state.quntity}
                        onChangeCheckoutPayload={this.onChangeCheckoutPayload}
                        onSubmitCheckout={this.onSubmitCheckout}
                        currency={this.state.currency}
                        checkoutScreen={true}
                        description={this.state.order_note}
                        placeOrder={this.placeOrders}
                        preferred_delivery_datetimeError={this.state.error}
                        purchaseOrderError={this.state.error}
                        clearError={this.clearError}
                        checkoutPayload={this.state.checkoutPayload}
                        rmxuser={storeInfo}
                        deleteFromCart={this.deleteFromCart}
                        onChangeOrderNote={this.onChangeOrderNote}

                      />
                    </Col>
                  )}

                  {this.state.isshowAddProduct &&
                    !isCheckout &&
                    !isShipping &&
                    !isBilling &&
                    !isOrderNote &&
                    !isPayment &&
                    !isOrderReview &&
                    !isShopingCart && (
                      <Col
                        xl={17}
                        lg={17}
                        xs={24}
                        sm={24}
                        md={24}
                        style={{ marginTop: "30px" }}
                      >
                        <AddProduct
                          productData={this.state.addproduct}
                          updateCartState={(e) => this.setState({ cart: e })}
                          isshowAddProduct={(
                            productDetail,
                            quntite,
                            totalPrice
                          ) => {
                            console.log("totalPrice==>", productDetail);
                            const ab = productDetail.rmx_product_additives.map(
                              (item) => {
                                return {
                                  rmx_product_additive_id: item.id,
                                  selected: item.selected ? 1 : 0,
                                };
                              }
                            );

                            const Obj = {
                              order_product: [
                                {
                                  order_product_additive: ab,
                                  quantity: quntite,
                                  rmx_product_id: this.state.addproduct.id,
                                  price: productDetail?.price,
                                },
                              ],
                              preferred_delivery_datetime: "",
                              preferred_delivery_period: "",
                              rmx_company_id: storeInfo?.id,
                              purchase_order_num: "",
                            };

                            this.setState({
                              isshowAddProduct: false,
                              totalPrice: totalPrice,
                              quntity: quntite,
                              placeOrderData: [
                                ...this.state.placeOrderData,
                                {
                                  order_product_additive: ab,
                                  quantity: quntite,
                                  rmx_product_id: this.state.addproduct.id,
                                  price: productDetail?.price,
                                },
                              ],
                              rmx_company_id: storeInfo?.id,
                            });
                          }}
                          onCheckout={(productDetail, quntite, totalPrice) => {
                            if (!cookies.get("contractor_credentials")) {
                              this.props.history.push("");
                              this.setState({
                                isOrderReview: false,
                                isShopingCart: false,
                                isshowAddProduct: false,
                                isOrderSuccess: false,
                                checkProgressValue: "Billing Address",
                                placeOrderData: [],

                                checkProgress: [
                                  {
                                    name: "Billing Address",
                                    isChecked: false,
                                  },
                                  {
                                    name: "Shipping Address",
                                    isChecked: false,
                                  },
                                  // {
                                  //   name: "Order Notes",
                                  //   isChecked: false,
                                  // },
                                  {
                                    name: "Payment Method",
                                    isChecked: false,
                                  },
                                  {
                                    name: "Order Review",
                                    isChecked: false,
                                  },
                                ],
                              });
                            } else {
                              this.props.history.push("/product/shoppingcart");
                              const data = JSON.parse(
                                localStorage?.getItem("cart")
                              );

                              const previousData = data
                                .filter(
                                  (item) =>
                                    item?.id !== this.state?.addproduct?.id
                                )
                                .map((item) => {
                                  return {
                                    price: item.actualProdcutPrice,
                                    quantity: item?.quantity,
                                    rmx_product_id: item?.id,
                                    order_product_additive:
                                      item?.rmx_product_additives
                                        ?.filter((v) => v?.selected)
                                        .map((c) => {
                                          return {
                                            selected: 1,
                                            rmx_product_additive_id: c.id,
                                          };
                                        }),
                                  };
                                });
                              const ab =
                                productDetail?.rmx_product_additives?.map(
                                  (item) => {
                                    return {
                                      rmx_product_additive_id: item?.id,
                                      selected: item.selected ? 1 : 0,
                                    };
                                  }
                                );

                              let Obj = {
                                order_product: [
                                  ...previousData,
                                  {
                                    order_product_additive: ab,
                                    quantity: quntite,
                                    rmx_product_id: this.state.addproduct.id,
                                    price: productDetail?.price,
                                  },
                                ],
                                preferred_delivery_datetime: "",
                                preferred_delivery_period: "",
                                rmx_company_id: storeInfo?.id,
                                purchase_order_num: "",
                              };
                              console.log("object==>", Obj);

                              this.props.orderPrice(Obj, () =>
                                this.setState({
                                  totalPrice: totalPrice,
                                  isShopingCart: true,
                                  quntity: quntite,
                                  placeOrderData: [
                                    ...previousData,
                                    {
                                      order_product_additive: ab,
                                      quantity: quntite,
                                      rmx_product_id: this.state.addproduct.id,
                                      price: productDetail?.price,
                                    },
                                  ],
                                  rmx_company_id: storeInfo?.id,
                                })
                              );
                            }
                          }}
                        />
                      </Col>
                    )}
                </Row>
              )}
              {this.state.keyTab === 2 && (
                <Row
                  style={{ marginTop: "50px", marginBottom: "20px" }}
                  gutter={[20, 0]}
                >
                  <Col span={6}>
                    <BussinessCard
                      isShowDots={true}
                      isShowAddress={true}
                      bussinessName={"Business Information"}
                      data={storeInfo}
                    />
                  </Col>
                  <Col
                    span={18}
                    style={{
                      minHeight: "330px",

                    }}
                  >
                    <h1 className="text-left business-name">
                      {storeInfo?.rmx_company_asset?.store_name}
                    </h1>
                    <h1
                      className="text-left business-link pointer-cursor"
                      onClick={() =>
                        window.open(
                          `${process.env.REACT_APP_LINK}://${rmxuser?.rmx_company_asset?.store_url}${process.env.REACT_APP_DOMAIN}`
                        )
                      }
                    >
                      {`${process.env.REACT_APP_LINK}://${rmxuser?.rmx_company_asset?.store_url}${process.env.REACT_APP_DOMAIN}`}
                    </h1>
                    <p className="text-left" style={{ marginTop: "10px" }}>
                      {storeInfo?.rmx_company_asset?.description}
                    </p>
                    <Row justify="start" style={{ marginTop: "80px" }}>
                      <Col span={24} className="text-left">
                        <Row>
                          <Col span={3} style={{ padding: "10px" }}>
                            <img src={rmxTotalPlant} />
                          </Col>
                          <Col span={3}>
                            <strong className="totalplant-count">
                              {storeInfo?.total_rmx_plants}
                            </strong>
                          </Col>
                          <Col span={12}>
                            <span className="totalproducts ">Total Plants</span>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={24} className="text-left">
                        <Row>
                          <Col span={3} style={{ padding: "10px" }}>
                            <img src={rmxTotalProducts} />
                          </Col>
                          <Col span={3}>
                            <strong className="totalplant-count">
                              {storeInfo?.total_rmx_products}
                            </strong>
                          </Col>
                          <Col span={12}>
                            <span className="totalproducts">
                              Total Products
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>

          <CustomModal
            visible={this.state.isOpenCard}
            onCancelModal={() =>
              this.setState({
                isOpenCard: false,
              })
            }
            footer={[]}
          >
            <Col xl={24}>
              <h5 className="text-center st-primary">Add Card</h5>
              <Divider />
            </Col>
            <Col xl={24} className="pointer-cursor">
              <Row>
                <Col xl={24}>
                  <form>
                    <Row justify="space-between" gutter={[5, 20]}>
                      <Col xl={24}>
                        <TextInput
                          label="Card Number "
                          name="number"
                          required
                          value={cardDetails.number}
                          onChange={this.cardHandleChanged}
                          maxLength={16}
                        />
                        <Row justify="end">
                          <Col span={24} className="text-right">
                            {" "}
                            <span className="danger-color text-right">
                              {numberError && numberError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={24}>
                        <TextInput
                          label="Expiry Month"
                          name="exp_month"
                          required
                          value={cardDetails.exp_month}
                          onChange={this.cardHandleChanged}
                        />
                        <Row justify="end">
                          <Col span={24} className="text-right">
                            {" "}
                            <span className="danger-color text-right">
                              {exp_monthError && exp_monthError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={24}>
                        <TextInput
                          label="Expiry Year"
                          name="exp_year"
                          required
                          value={cardDetails.exp_year}
                          onChange={this.cardHandleChanged}
                        />
                        <Row justify="end">
                          <Col span={24} className="text-right">
                            {" "}
                            <span className="danger-color text-right">
                              {exp_yearError && exp_yearError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={24}>
                        <TextInput
                          label="CVC"
                          name="cvc"
                          required
                          value={cardDetails.cvc}
                          onChange={this.cardHandleChanged}
                        />
                        <Row justify="end">
                          <Col span={24} className="text-right">
                            {" "}
                            <span className="danger-color text-right">
                              {cvcError && cvcError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={24}>
                        <Row justify="end">
                          <Col span={24} className="text-right">
                            {!this.props.isCardReqLoading && (
                              <Button
                                style={{
                                  backgroundColor: "#ff9800",
                                  color: "#fff",
                                  width: "30%",
                                  border: "none",
                                }}
                                onClick={() => {
                                  this.onSubmitCard();
                                }}
                                disabled={this.state.isDisabled}
                              >
                                Save
                              </Button>
                            )}
                            {this.props.isCardReqLoading && (
                              <img src={LoaderGif} height="60" width={60} />
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </form>
                </Col>
              </Row>
            </Col>
          </CustomModal>

          <CustomModal
            visible={this.state.isShowLoginModal}
            onCancelModal={() =>
              this.setState({
                isShowLoginModal: false,
                userObj: { email: "", password: "" },
                authError: "",
              })
            }
            footer={[]}
          >
            <Row justify="center">
              <Col span={24} className="text-center">
                <h5
                  style={{
                    fontSize: "20px",
                    lineHeight: "15px",
                    margin: "0.82rem 0 0.656rem 0",
                    color: " #323761",
                  }}
                >
                  Login Credentials
                </h5>
              </Col>
              <Col span={24} className="text-center">
                <p style={{ color: "#9e9e9e", marginTop: "5px" }}>
                  Already Registered? Please Login Below.
                </p>
              </Col>
              <Col xl={22} style={{ marginTop: "15px" }}>
                <form>
                  <Row justify="center">
                    <Col xl={24}>
                      <TextInput
                        label="Username"
                        type="email"
                        value={userObj.email}
                        onChange={(e) =>
                          this.setState({
                            userObj: {
                              ...this.state.userObj,
                              email: e.target.value,
                            },
                            errorObj: {
                              ...this.state.errorObj,
                              emailError: "",
                            },
                            authError: "",
                          })
                        }
                      />
                      <Row justify="end">
                        <Col span={24} className="text-right">
                          {" "}
                          <span className="danger-color text-right">
                            {emailError && emailError}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Password"
                        type="password"
                        value={userObj.password}
                        onChange={(e) =>
                          this.setState({
                            userObj: {
                              ...this.state.userObj,
                              password: e.target.value,
                            },
                            errorObj: {
                              ...this.state.errorObj,
                              passwordError: "",
                            },
                            authError: "",
                          })
                        }
                      />
                      <Row justify="end">
                        <Col span={24} className="text-right">
                          {" "}
                          <span className="danger-color text-right">
                            {passwordError && passwordError}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </form>
              </Col>
              <Col span={24}>
                <span className="text-center d-grid danger-color">
                  {authError && authError}
                </span>
              </Col>
              <Col
                span={24}
                className="text-center"
                style={{ margin: "20px 0px" }}
              >
                <small
                  style={{ fontSize: "90%" }}
                  className="pointer-cursor"
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_LINK}://app${process.env.REACT_APP_DOMAIN}/#/customer/forgot`
                    )
                  }
                >
                  Forgot Password?
                </small>
              </Col>
              <Col span={20}>
                <Row align="middle" justify="space-between" gutter={[10, 0]}>
                  <Col span={12} className="pointer-cursor">
                    <Button
                      style={{
                        backgroundColor: "#f9a01b",
                        color: "#fff",
                        border: "none",
                        width: "100%",
                      }}
                      onClick={() => {
                        if (
                          !userObj.email.trim().length ||
                          !userObj.password.trim().length
                        ) {
                          if (!userObj.email.trim().length) {
                            this.state.errorObj.emailError =
                              "Username is required.";
                          }
                          if (!userObj.password.trim().length) {
                            this.state.errorObj.passwordError =
                              "Password is required.";
                          }
                          this.setState({ errorObj: this.state.errorObj });
                          return;
                        }
                        signin(userObj, () => {
                          this.setState({
                            isShowLoginModal: false,
                            isshowAddProduct: true,
                            userObj: { email: "", password: "" },
                          });
                          this.props.history.push("/product");
                        });
                      }}
                    >
                      LOGIN
                    </Button>
                    {/* {loader && (
                      <img src={LoaderGif} height={"60"} width={"60"} />
                    )} */}
                  </Col>
                  <Col span={12} className="pointer-cursor">
                    <Button
                      style={{
                        backgroundColor: "#00796b",
                        color: "#fff",
                        width: "100%",
                        border: "none",
                      }}
                      onClick={() =>
                        window.open(
                          `${process.env.REACT_APP_LINK}://app${process.env.REACT_APP_DOMAIN}/#/customer/register`
                        )
                      }
                    >
                      REGISTER
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CustomModal>
        </Col >
      </Row >
    );
  }
}

const mapStateToProps = (store) => {
  return {
    categories: store.CatalogReducer.categories,
    products: store.CatalogReducer.products,
    metaData: store.CatalogReducer.metaData,
    orderData: store.UserReducer.orderData,
    isLoading: store.CatalogReducer.isLodading,
    isCardLoading: store.UserReducer.isLoading,
    isCardReqLoading: store.UserReducer.isCardReqLoading,
    storeInfo: store?.AuthReducer?.storeInfo,
    loader: store?.AuthReducer?.loader,
    error: store?.AuthReducer?.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCategories: (params) => dispatch(CatalogAction.getCategoriesReq(params)),
    getProducts: (params, isTrue) =>
      dispatch(CatalogAction.getProductReq(params, isTrue)),
    postOrderAddress: (payload, id, cb) =>
      dispatch(UserAction.postOrderAddressReq(payload, id, cb)),
    getCardReq: (cb, route) => dispatch(UserAction.getCardsReq(cb, route)),
    getStoreUrl: (route) => dispatch(AuthAction.getStoreUrlReq(route)),
    orderPrice: (body, cb) => dispatch(UserAction.orderPriceReq(body, cb)),
    createOrder: (body, cb) => dispatch(UserAction.createOrderReq(body, cb)),
    updateOrder: (body, id, cb) =>
      dispatch(UserAction.updateOrderReq(body, id, cb)),
    placeOrder: (body, id, cb) =>
      dispatch(UserAction.postChargesReq(body, id, cb)),
    creditPurchaseOrder: (body, id, cb) =>
      dispatch(UserAction.postCreditChargesReq(body, id, cb)),
    createToken: (payload, cb, callback) =>
      dispatch(UserAction.createTokenReq(payload, cb, callback)),
    getAddressReq: (params) => dispatch(UserAction.getAddressReq(params)),
    signin: (payload, cb) => dispatch(AuthAction.SignIn(payload, cb)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlantDetails);
